/* unplugin-vue-components disabled */import script from "./SingleNote.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleNote.vue?vue&type=script&setup=true&lang=ts"

import "./SingleNote.vue?vue&type=style&index=0&id=12a3f0f7&lang=scss&scoped=true"
import "./SingleNote.vue?vue&type=style&index=1&id=12a3f0f7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a3f0f7"]])

export default __exports__